@if (mode !== undefined) {
	@if (mode === OfferDropdownItemMode.MAT_TERM) {
		<app-mat-term-item [activeText]="activeText$ | async"></app-mat-term-item>
	}
	@if (mode === OfferDropdownItemMode.PARTICIPANTS) {
		<app-participants
			[productId]="productId"
			[displayOnlyAdults]="isYouthCamp$ | async"
			[transportKind]="transportKind()"
		></app-participants>
	}
	@if (mode === OfferDropdownItemMode.ROOM_TYPES) {
		<app-room-types [productId]="productId" [activeText]="activeText$ | async"></app-room-types>
	}
	@if (mode === OfferDropdownItemMode.DEPARTURE) {
		<app-departure [activeText]="activeText$ | async" [transportKind]="transportKind()"></app-departure>
	}
	@if (mode === OfferDropdownItemMode.BOARDS) {
		<app-boards [productId]="productId" [activeText]="activeText$ | async"></app-boards>
	}
	@if (mode === OfferDropdownItemMode.PROMOTIONS) {
		<app-promotion-catalogs [activeText]="activeText$ | async"></app-promotion-catalogs>
	}
}
